import { API2_HOST } from '../../helpers/urlHelper';
import {
  baseSearch,
  basePost,
  basePatch
} from 'services/base-services/baseService';

const baseURL = `${API2_HOST}/sp-sales-customers`;
const search = async request => {
  return await baseSearch(baseURL, request);
};
const createNewVisit = async request => {
  return await basePost(`${baseURL}/new-visit`, request);
};
const post = async request => {
  return await basePost(baseURL, request);
};

const patch = async (id, request) => {
  return await basePatch(baseURL, request, id);
};

const getVisitHistory = async (request) => {
  return await baseSearch(`${baseURL}/visit`, request);
};

// const getVisitHistory = async request => {
//   return await baseSearch(
//     `http://localhost:5095/v1/sp-sales-customers/visit`,
//     request
//   );
// };

export { search, post, patch, createNewVisit, getVisitHistory };
